import { h, createContext } from 'preact';
import { useRef, useState, useContext, useCallback } from 'preact/hooks';

const ProductGalleryContext = createContext(null);

export const useGallery = () => useContext(ProductGalleryContext);

export const GalleryProvider = ({ children }) => {
  const [playingVideoIds, setPlayingVideoIds] = useState(new Set());
  const videoRefs = useRef({});

  const registerVideoRef = (id, ref) => {
    videoRefs.current[id] = ref;
  };

  const playVideo = (id) => {
    const ref = videoRefs.current[id];
    if (!ref) return;
    if (ref.paused) {
      Object.entries(videoRefs.current).forEach(([otherId, otherRef]) => {
        // Pause all other videos
        if (otherId !== id && otherRef && !otherRef.paused) otherRef.pause();
      });

      ref.play();
    }
  };

  const pauseVideo = (id) => {
    const ref = videoRefs.current[id];
    if (!ref?.paused) {
      ref?.pause();
    }
  };

  const toggleVideo = (id) => {
    const ref = videoRefs.current[id];
    if (!ref) return;

    if (ref.paused) {
      playVideo(id);
    } else {
      pauseVideo(id);
    }
  };

  const handleVideoPlay = useCallback((id) => {
    setPlayingVideoIds((prev) => new Set(prev).add(id))
  }, []);

  const handleVideoPause = useCallback((id) => {
    setPlayingVideoIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, [])



  return (
    <ProductGalleryContext.Provider
      value={{
        playingVideoIds,
        registerVideoRef,
        playVideo,
        pauseVideo,
        toggleVideo,
        handleVideoPlay,
        handleVideoPause,
      }}
    >
      {children}
    </ProductGalleryContext.Provider>
  );
};